import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountIdByProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetAccountIdByProjectQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, adobeAssetId?: string | null, workspace?: { __typename?: 'Workspace', id: string, accountId?: string | null, account?: { __typename?: 'Account', id: string, version?: number | null } | null } | null } | null } | null };


export const GetAccountIdByProject = /*#__PURE__*/ gql`
    query GetAccountIdByProject($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      adobeAssetId
      workspace {
        id
        accountId
        account {
          id
          version
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAccountIdByProjectQuery, GetAccountIdByProjectQueryVariables>;

          

          export const useGetAccountIdByProjectQuery = (options?:QueryHookOptions<GetAccountIdByProjectQuery, GetAccountIdByProjectQueryVariables>) => useQuery(GetAccountIdByProject, options);

          

          export type GetAccountIdByProjectQueryOptions = QueryHookOptions<GetAccountIdByProjectQuery, GetAccountIdByProjectQueryVariables>;

          

          export const useGetAccountIdByProjectLazyQuery = (options?:LazyQueryHookOptions<GetAccountIdByProjectQuery, GetAccountIdByProjectQueryVariables>) => useLazyQuery(GetAccountIdByProject, options);

          

          export type GetAccountIdByProjectQueryResult = ReturnType<typeof useGetAccountIdByProjectQuery>;

          
